import React, { useMemo } from "react";
import classes from "./DescriptorPricingBox.module.scss";
import Descriptor from "../../features/rapidstor/entities/Descriptor";
import { monthlyToWeekly } from "../../features/helpers";

interface Props {
  descriptor: Descriptor;
}

function DescriptorPricingBox({ descriptor }: Props) {
  const unitType = useMemo(() => {
    if (descriptor.unitTypes.length === 0) {
      return null;
    }
    const unitTypes = [...descriptor.unitTypes].sort((a, b) => {
      if (a.hasComputedAvailable === b.hasComputedAvailable) {
        return a.rates.discountedRate - b.rates.discountedRate;
      }
      return a.hasComputedAvailable ? -1 : 1;
    });
    return unitTypes[0];
  }, [descriptor]);

  const savings = useMemo(() => {
    if (!unitType) {
      return 0;
    }

    const standardRate = unitType.rates.rate;
    const discountedRate = unitType.rates.discountedRate;
    return (standardRate - discountedRate).toLocaleString("en-GB", {
      currency: "GBP",
      currencyDisplay: "symbol",
      style: "currency",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      trailingZeroDisplay: "stripIfInteger",
    });
  }, [unitType]);

  if (!unitType) {
    return null;
  }
  return (
    <>
      {/* <h4 className={classes.header_text}>Online Storage Price</h4> */}
      {unitType.deal ? (
        <div className={classes.pricing_box}>
          <div className={classes.top}>
            <div className={classes.discounted_title}>
              <h5>{unitType.deal.title}</h5>
              <div className={classes.savings_box}>
                <span>SAVE</span>
                <span>{savings}</span>
              </div>
            </div>
            <div className={classes.discounted_rate}>
              <h4>£{monthlyToWeekly(unitType.rates.discountedRate)}</h4>
              <span>per week</span>
            </div>
          </div>
          <hr />
          <div className={classes.bottom}>
            <span>Price after discount period</span>
            <strong>£{monthlyToWeekly(unitType.rates.rate)} per week</strong>
          </div>
        </div>
      ) : (
        <div className={classes.pricing_box}>
          <div className={classes.top}>
            <div className={classes.discounted_title}>
              <h5>Rental Rate</h5>
            </div>
            <div className={classes.discounted_rate}>
              <h4>£{monthlyToWeekly(unitType.rates.discountedRate)}</h4>
              <span>per week</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DescriptorPricingBox;
